import * as React from 'react';
import { useNavigationType } from 'react-router-dom';

/**
 * Clears the persisted wizard draft (step + form data) when the page is entered
 * through a navigation, so "Create a new offer" always restarts from the first step.
 * On POP (page reload / browser back) the draft is kept, so an in-progress form is not lost.
 *
 * Runs during render, before the form reads the keys with useLocalStoragePersistState.
 */
export const useResetPersistedFormDraft = (keys: string[]): void => {
  const navigationType = useNavigationType();
  const cleared = React.useRef(false);

  if (!cleared.current) {
    cleared.current = true;

    if (navigationType !== 'POP') {
      keys.forEach((key) => window.localStorage.removeItem(key));
    }
  }
};
